import React from 'react';
import PropTypes from 'prop-types';
import Warning from 'jsx/elements/messages/Warning';
import { splitSsn } from 'utils/strings';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

function MonitoringInsertResult({ data, onClose, isOpen }) {
  const { t } = useLocale();
  let ind = [];
  let broken = [];
  if (data && data.keywordValidationResults) {
    ind = data.keywordValidationResults.filter((r) => {
      return r.keyword < '4000000000';
    });
    broken = data.keywordValidationResults.filter((r) => {
      return !r.success;
    });
  }
  const total = data ? data.inserting + data.updating + data.failed : 0;

  const styling = {
    maxHeight: '0px',
    overflowY: 'hidden',
    transition: 'all .3s ease-in',
  };

  if (isOpen) {
    styling.maxHeight = '500px';
  }
  return (
    <div style={styling} className={isOpen ? 'gutter-top' : ''}>
      <Warning
        messageType="info"
        messageHeader={t('portfolioMonitoring_insertResult_header')}
        extraClass="no-gutter-bottom"
        onClose={onClose}
      />
      <div style={{ padding: '20px' }} className="box no-shadow">
        {data && (
          <div className="grid collapse960 text-14">
            <div className="col s1of3">
              <div className="grid">
                <div className="col s7of12 text-semibold">
                  {t('portfolioMonitoring_insertResult_uploadedRegnos')}
                </div>
                <div className="col s5of12">{total}</div>
              </div>
              <div className="grid">
                <div className="col s7of12 text-semibold">
                  {t('portfolioMonitoring_insertResult_invalidRegnos')}
                </div>
                <div className="col s5of12">{data.failed}</div>
              </div>
            </div>
            <div className="col s1of3">
              <div className="grid">
                <div className="col s7of12 text-semibold">
                  {t('portfolioMonitoring_insertResult_updatedRegnos')}
                </div>
                <div className="col s5of12">{data.updating}</div>
              </div>
              <div className="grid">
                <div className="col s7of12 text-semibold">
                  {t('portfolioMonitoring_insertResult_newRegnos')}
                </div>
                <div className="col s5of12">{data.inserting}</div>
              </div>
            </div>
            <div className="col s1of3">
              <div className="grid">
                <div className="col s7of12 text-semibold">
                  {t('portfolioMonitoring_insertResult_individuals')}
                </div>
                <div className="col s5of12">{ind.length}</div>
              </div>
              <div className="grid">
                <div className="col s7of12 text-semibold">
                  {t('portfolioMonitoring_insertResult_companies')}
                </div>
                <div className="col s5of12">{total - ind.length}</div>
              </div>
            </div>
          </div>
        )}
        {data && broken.length > 0 && (
          <div className="gutter-top">
            <div className="divider" />
            <div className="text-14 text-bold">
              {t('portfolioMonitoring_insertResult_list_invalidRegnos')}
            </div>
            <div className="text-14">
              {broken.map((r, i) => {
                if (i === broken.length - 1) {
                  return <span key={i}>{splitSsn(r.keyword)}</span>;
                }
                return <span key={i}>{splitSsn(r.keyword) + ', '}</span>;
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

MonitoringInsertResult.propTypes = {
  data: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default MonitoringInsertResult;
